// src/i18n/fr.js
export const fr = {
  // ── Shared ────────────────────────────────────────────────────────────────
  loading: 'Chargement…',
  close: 'Fermer',
  save: 'Enregistrer',
  saved: '✓ Enregistré !',
  saving: 'Enregistrement…',
  cancel: 'Annuler',
  delete: 'Supprimer',
  error_generic: 'Une erreur est survenue.',

  // ── WheelSpinner ──────────────────────────────────────────────────────────
  wheel_loading: 'Chargement de la roue…',
  wheel_headline_default: 'Tournez pour gagner !',
  wheel_sub_default: 'Appuyez sur la roue pour votre récompense ✨',
  wheel_tap_hint: '↑ Appuyez au centre pour tourner',
  wheel_guaranteed_badge: '⭐ Tour garanti !',
  wheel_error_not_found: 'Établissement introuvable. Veuillez scanner un QR code valide.',
  wheel_error_eligibility: 'Impossible de vérifier votre éligibilité.',
  wheel_error_owner: 'Cette fonctionnalité est réservée aux clients. Connectez-vous avec un compte client.',
  wheel_not_eligible_title: 'Vous avez déjà joué aujourd\'hui dans cet établissement. Revenez demain !',
  wheel_view_rewards: 'Voir mes récompenses →',
  wheel_stamp_label: '🎟️ Carte de fidélité',
  wheel_stamp_progress: 'gagnez',
  wheel_guaranteed_count_one: '🌟 Vous avez 1 tour garanti !',
  wheel_guaranteed_count_many: (n) => `🌟 Vous avez ${n} tours garantis !`,
  wheel_review_cta_title: 'Vous avez apprécié votre visite ?',
  wheel_review_cta_button: 'Laisser un avis Google ⭐',
  wheel_pre_spin_review_cta: `Tournez la roue, laissez un avis, récupérez votre cadeau lors de votre prochaine visite ⭐`,
  wheel_pre_spin_review_button: 'Laisser un avis Google ⭐',

  // ── PrizeDisplay ──────────────────────────────────────────────────────────
  prize_you_won: 'Vous avez gagné',
  prize_congrats: 'Félicitations ! 🎉',
  prize_better_luck: 'Pas de chance cette fois !',
  prize_come_back: 'Revenez demain pour un nouveau tour',
  prize_coupon_label: 'Votre code promo',
  prize_coupon_hint: 'Montrez ce code au personnel pour en bénéficier',
  prize_coupon_locked_hint: 'Affiché après avoir laissé un avis',
  prize_claim: 'Récupérer mon lot 🎉',
  prize_claim_with_review: 'Laissez un avis et récupérez 🌟',
  prize_claim_no_review: 'Récupérer sans avis',
  prize_try_again: 'Réessayer demain',
  prize_review_prompt: 'Envie de partager votre expérience ?',
  prize_review_prompt_with_name: (name) => `Envie de soutenir ${name} avec un avis ?`,
  prize_review_button: 'Laisser un avis Google 🌟',
  prize_review_button_soft: 'Partager votre expérience →',

  // ── UserDashboard ─────────────────────────────────────────────────────────
  dash_loading: 'Chargement de vos récompenses…',
  dash_greeting: 'Bonjour',
  dash_subtitle: 'Votre tableau de bord récompenses',
  dash_stat_total: 'Total gagné',
  dash_stat_active: 'Actif',
  dash_stat_claimed: 'Réclamé',
  dash_error: 'Impossible de charger les récompenses.',
  dash_expiry_warning_title: (n) => `${n} lot${n > 1 ? 's' : ''} expire${n > 1 ? 'nt' : ''} bientôt !`,
  dash_expiry_warning_suffix: (name, days) => `"${name}" (${days}j restants)`,
  dash_stamp_section: '🎟️ Vos cartes de fidélité',
  dash_stamp_progress: 'tampons · gagnez',
  dash_guaranteed_badge: (n) => `⭐ ${n} garanti${n > 1 ? 's' : ''}`,
  dash_use_guaranteed: 'Utiliser mon tour garanti →',
  dash_filter_all: 'Tous les lots',
  dash_filter_active: 'Actifs',
  dash_filter_claimed: 'Réclamés',
  dash_filter_expired: 'Expirés',
  dash_badge_claimed: 'Réclamé',
  dash_badge_expired: 'Expiré',
  dash_won_on: 'Gagné le',
  dash_empty_title_no_rewards: 'Aucune récompense pour l\'instant',
  dash_empty_title_filtered: 'Rien ici',
  dash_empty_body_no_rewards: 'Visitez un établissement, scannez leur QR code et tournez la roue !',
  dash_empty_body_filtered: 'Essayez un autre filtre pour voir d\'autres récompenses.',
  dash_find_restaurants: 'Trouver des établissements',
  dash_review_nudge_title: 'Vous avez apprécié votre visite ?',
  dash_review_nudge_body: 'Aidez-les en laissant un avis Google.',
  dash_review_nudge_button: 'Laisser un avis ⭐',
  dash_review_nudge_dismiss: 'Plus tard',

  // ── SettingsTab ───────────────────────────────────────────────────────────
  settings_section_branding: 'Personnalisation de la page de jeu',
  settings_section_branding_sub: 'Ce que vos clients voient lorsqu\'ils scannent votre QR code',
  settings_section_stamp: 'Carte de fidélité',
  settings_section_stamp_sub: 'Récompensez les clients qui reviennent',
  settings_section_revenue: 'Suivi des revenus',
  settings_section_revenue_sub: 'Utilisé pour estimer le ROI de votre programme de fidélité',
  settings_name_label: 'Nom de l\'établissement',
  settings_name_hint: 'Nom affiché sur la roue et dans le tableau de bord.',
  settings_name_placeholder: 'ex. Chez Marcel',
  settings_google_review_label: 'Lien Google Avis',
  settings_google_review_hint: 'Utilisez le lien court généré par Google Business — pas une URL Google Maps classique.',
  settings_google_review_placeholder: 'https://g.page/r/...',
  settings_headline_label: 'Titre',
  settings_headline_hint: 'Affiché au-dessus de la roue — par défaut : "Tournez pour gagner !"',
  settings_headline_placeholder: 'ex. Tournez et gagnez chez Marcel !',
  settings_sub_label: 'Sous-titre',
  settings_sub_hint: 'Affiché sous le titre',
  settings_sub_placeholder: 'ex. Laissez un avis et tentez votre chance !',
  settings_bg_label: 'Image de fond',
  settings_bg_hint: 'Affichée derrière la roue (jpg/png/webp).',
  settings_logo_label: 'Logo central de la roue',
  settings_logo_hint: 'Petit logo affiché au centre de la roue. Format circulaire, ~80px.',
  settings_stamp_enable: 'Activer la carte de fidélité',
  settings_stamp_enable_sub: 'Les clients gagnent un lot garanti après N tours',
  settings_stamp_goal_label: 'Tours requis pour un lot garanti',
  settings_stamp_prize_label: 'Nom du lot garanti',
  settings_stamp_prize_hint: 'Ce qu\'ils gagnent quand ils complètent leur carte',
  settings_stamp_prize_placeholder: 'ex. Café offert',
  settings_stamp_info: (goal, prize) =>
    `Les clients verront une barre de progression : tous les ${goal || 5} tours, ils gagnent un "${prize || 'Lot offert'}" garanti.`,
  settings_avg_ticket_label: 'Valeur moyenne du ticket client (€)',
  settings_avg_ticket_hint: 'Dépense moyenne par visite — utilisée pour estimer les revenus générés par les visites répétées',
  settings_section_rewards: 'Lots',
  settings_section_rewards_sub: 'Durée de validité des lots gagnés à la roue',
  settings_expiry_label: 'Expiration des lots (jours)',
  settings_expiry_hint: 'Nombre de jours pendant lesquels un client peut venir récupérer un lot gagné',
  settings_error: 'Impossible d\'enregistrer les paramètres.',

  // ── AdminDashboard ────────────────────────────────────────────────────────
  admin_loading: 'Chargement du tableau de bord…',
  admin_section_restaurants: 'Vos établissements',
  admin_add_restaurant: '+ Ajouter un établissement',
  admin_no_restaurants: 'Aucun établissement pour l\'instant',
  admin_select_restaurant: 'Sélectionnez un établissement',
  admin_select_hint: 'Choisissez un établissement dans la liste pour gérer ses paramètres.',
  admin_new_name_label: 'Nom de l\'établissement',
  admin_new_name_placeholder: 'ex. Chez Marcel',
  admin_new_theme_label: 'Couleur du thème',
  admin_new_expiry_label: 'Expiration des récompenses (jours)',
  admin_add_button: 'Ajouter l\'établissement',
  admin_error_name_required: 'Le nom de l\'établissement est obligatoire',
  admin_error_load: 'Impossible de charger vos établissements.',
  admin_error_add: 'Impossible d\'ajouter l\'établissement. Veuillez réessayer.',
  admin_error_delete: 'Impossible de supprimer l\'établissement.',
  admin_success_add: 'Établissement ajouté ! Configurez votre roue de prix ci-dessous.',
  admin_success_delete: (name) => `"${name}" supprimé avec succès.`,
  admin_expiry_days: (n) => `${n}j d'expiration`,
  admin_delete_title: 'Supprimer l\'établissement',
  admin_delete_body: (name) => `Êtes-vous sûr de vouloir supprimer "${name}" ? Cette action est irréversible.`,
  admin_tab_prizes: 'Lots',
  admin_tab_customers: 'Clients',
  admin_tab_analytics: 'Analytiques',
  admin_tab_qrcode: 'QR Code',
  admin_tab_settings: 'Paramètres',

  // ── Landing ───────────────────────────────────────────────────────────────
  landing_eyebrow: 'Pour les Établissements',
  landing_h1_line1: 'Plus d\'avis.',
  landing_h1_line2: 'Des clients fidèles.',
  landing_h1_line3: 'Zéro effort.',
  landing_subheadline: 'Loyal Spin transforme chaque visite en avis Google et chaque avis en raison de revenir. Configurez votre roue en quelques minutes, imprimez un QR code, et laissez-le tourner tout seul.',
  landing_cta_primary: 'Commencer gratuitement →',
  landing_cta_secondary: 'Démarrer en 5 minutes ↓',
  landing_stat_reviews: 'Avis générés',
  landing_stat_setup: 'Mise en place',
  landing_stat_revenue: 'Revenus estimés',
  landing_steps_heading: 'Opérationnel en quatre étapes',
  landing_step1_title: 'Créez votre établissement',
  landing_step1_desc: 'Inscrivez-vous, ajoutez votre établissement et nommez vos lots — bon de réduction, cadeau offert, tout ce que vous choisissez.',
  landing_step2_title: 'Imprimez votre QR code',
  landing_step2_desc: 'Téléchargez votre QR code unique et placez-le en vitrine, à l\'accueil ou sur votre comptoir. Un seul code. Aucune appli requise.',
  landing_step3_title: 'Les clients laissent un avis et jouent',
  landing_step3_desc: 'Les clients scannent, laissent un avis Google, puis tournent la roue pour gagner un vrai lot sur place.',
  landing_step4_title: 'Regardez vos avis grimper',
  landing_step4_desc: 'Suivez les tours, les lots gagnés et l\'activité des clients depuis votre tableau de bord — tout au même endroit.',
  landing_feat1_title: 'Plus d\'avis Google',
  landing_feat1_desc: 'Chaque tour est associé à un avis. Transformez le passage en client en notes 5 étoiles automatiquement.',
  landing_feat2_title: 'Des lots que vous maîtrisez',
  landing_feat2_desc: 'Définissez vos propres récompenses avec des probabilités personnalisées. Vous décidez ce que vous offrez.',
  landing_feat3_title: 'Tableau de bord en temps réel',
  landing_feat3_desc: 'Voyez qui joue, ce qu\'ils gagnent et comment votre réputation évolue.',
  landing_customer_heading: 'Fluide pour vos clients — automatique pour vous',
  landing_customer_sub: 'Aucune appli à télécharger. Aucun compte requis. Scannez, laissez un avis, et jouez.',
  landing_customer_caption: 'Fonctionne sur tous les téléphones. Sans téléchargement. Sans friction.',
  landing_cstep1_title: 'Scannez le QR code',
  landing_cstep1_desc: 'Un scan depuis son téléphone ouvre instantanément la roue dans le navigateur.',
  landing_cstep2_title: 'Laissez un avis Google',
  landing_cstep2_desc: 'Ils partagent leur expérience — votre réputation grandit à chaque visite.',
  landing_cstep3_title: 'Tournez et récupérez leur lot',
  landing_cstep3_desc: 'Ils font tourner la roue et obtiennent une vraie récompense, là, dans votre établissement.',
  landing_bottom_cta_q: 'développer vos avis ?',
  landing_bottom_cta_body: 'Rejoignez des centaines d\'établissements qui utilisent Loyal Spin pour fidéliser leurs clients.',
  landing_bottom_cta_signin: 'Accéder à votre tableau de bord',
  landing_go_dashboard: 'Mon tableau de bord →',
  landing_go_rewards: 'Mes récompenses →',

  // ── Login ─────────────────────────────────────────────────────────────────
  login_title_spin: 'Prêt à jouer ?',
  login_title_default: 'Loyal Spin',
  login_sub_spin: 'Connectez-vous pour accéder à votre roue',
  login_sub_default: 'Connectez-vous pour gérer votre profil et vos récompenses',

  // ── LoginForm ─────────────────────────────────────────────────────────────
  login_tab_customer: 'Client',
  login_tab_owner: 'Propriétaire',
  login_google_spin: 'Continuer avec Google',
  login_google_customer: 'Se connecter en tant que client',
  login_google_owner: 'Se connecter en tant que propriétaire',
  login_hint_spin: 'Connectez-vous pour jouer et récupérer votre lot',
  login_error: 'Connexion échouée. Veuillez réessayer.',

  // ── Navbar ────────────────────────────────────────────────────────────────
  nav_dashboard_owner: '⚙ Tableau de bord',
  nav_dashboard_customer: '🎁 Mes récompenses',
  nav_sign_out: 'Déconnexion',
  nav_sign_in: 'Se connecter',
  nav_home: 'Accueil',
  nav_admin: 'Admin',
  nav_rewards: 'Récompenses',

  // ── PrizeManagement ───────────────────────────────────────────────────────
  prizes_loading: 'Chargement des lots…',
  prizes_total_prob: 'Probabilité totale',
  prizes_min_warning: 'Minimum 3 lots requis',
  prizes_max_warning: 'Trop de lots (max 10)',
  prizes_name_label: 'Nom du lot *',
  prizes_name_placeholder: 'ex. Boisson offerte',
  prizes_prob_label: 'Probabilité (%)',
  prizes_no_reward_label: 'Aucun lot (Réessayez)',
  prizes_color_label: 'Couleur',
  prizes_no_reward_badge: 'Aucun lot',
  prizes_delete_title: 'Supprimer le lot',

  // ── QRCodeGenerator ───────────────────────────────────────────────────────
  qr_error_low: 'Faible (7%)',
  qr_error_medium: 'Moyen (15%)',
  qr_error_quartile: 'Quart (25%)',
  qr_error_high: 'Élevé (30%)',

  // ── CustomersTab ──────────────────────────────────────────────────────────
  customers_loading: 'Chargement des clients…',
  customers_search_placeholder: 'Rechercher par nom ou email…',
  customers_sort_last_spin: 'Dernier tour',
  customers_sort_spins: 'Plus de tours',
  customers_sort_prizes: 'Plus de lots',
  customers_col_spins: 'tours',
  customers_col_prizes: 'lots',
  customers_col_last_spin: 'dernier tour',
  customers_spin_history: 'Historique des tours',
  customers_winback_title: 'Campagne de réactivation',
  customers_bonus_hint: 'Les liens de tour bonus expirent en 7 jours · Un usage par lien',

  // ── AnalyticsTab ──────────────────────────────────────────────────────────
  analytics_loading: 'Chargement des analytiques…',
  analytics_no_data: 'Pas encore de données',
  analytics_no_data_hint: 'Partagez votre QR code pour commencer à collecter des tours.',
  analytics_spins_title: 'Tours — 14 derniers jours',
  analytics_prizes_title: 'Répartition des lots',
  analytics_return_customers: 'Clients fidèles',
  analytics_return_customers_sub: 'ont visité 2+ fois',
  analytics_return_visits: 'Visites répétées',
  analytics_return_visits_sub: 'tours au-delà du 1er',

  // ── Footer ────────────────────────────────────────────────────────────────
  footer_legal_mentions: 'Mentions légales',
  footer_legal_cgu: 'CGU',
  footer_legal_reglement: 'Règlement des jeux',
  footer_legal_confidentialite: 'Confidentialité',
  footer_legal_cookies: 'Cookies',
  footer_legal_contact: 'Contact',
  footer_rights: (year) => `© ${year} Loyal Spin. Tous droits réservés.`,
};
